import React from "react";
import CollapsibleWrapper from "../CollapsibleWrapper";
import ErrorBoundary from "../ErrorBoundary";
import EnhancedJsonRenderer from "../format-json-content";

const DraftMessageContent = ({
  msg,
  index,
  messageId,
  initialExpanded,
  onToggle,
  shouldCollapseByValue,
  renderCopyButton,
  styles,
  selectedDiffLines,
  handleDiffLineClick,
  diffComments,
  handleCommentChange,
}) => {
  if (msg.context === "NULL") {
    return (
      <div className={`message-content-wrapper ${styles.messageContentWrapper || ''}`}>
        <div className={styles.projectCompletionMessage}>项目成功完成！</div>
      </div>
    );
  }

  if (typeof msg.context === 'string') {
    return (
      <div className={`message-content-wrapper ${styles.messageContentWrapper || ''}`}>
        <CollapsibleWrapper 
          messageId={messageId}
          collapsible={shouldCollapseByValue(msg.context)}
          initialExpanded={initialExpanded}
          onToggle={onToggle}
        >
          <div className={styles.messageContent}>{msg.context}</div>
        </CollapsibleWrapper>
        {renderCopyButton(msg.context)}
      </div>
    );
  }

  return (
    <div className={`message-content-wrapper ${styles.messageContentWrapper || ''}`}>
      <CollapsibleWrapper 
        messageId={messageId}
        collapsible={shouldCollapseByValue(msg.context)}
        initialExpanded={initialExpanded}
        onToggle={onToggle}
      >
        <ErrorBoundary>
          <EnhancedJsonRenderer
            content={msg.context}
            selectedLines={selectedDiffLines[index] || []}
            onLineClick={(lineIndex) => handleDiffLineClick(index, lineIndex)}
            comments={diffComments[index] || {}}
            onCommentChange={(lineIndex, comment) =>
              handleCommentChange(index, lineIndex, comment)
            }
          />
        </ErrorBoundary>
      </CollapsibleWrapper>
      {renderCopyButton(msg.context)}
    </div>
  );
};

export default React.memo(DraftMessageContent);
